import React, {useContext} from 'react';  
import { Route, Redirect, withRouter } from "react-router-dom";
import { AuthContext } from "../../components/FirebaseAuth";
import PublicTemplate from "../../components/templates/PublicTemplate";
import Loader from "../../components/Loader";

const AuthRouter = ({component: Component, template: Template, title: Title, allowRoles, ...rest}) => {
    
    document.title = Title;

    const {authUser} = useContext(AuthContext);
    
    return ( 
        <Route
            {...rest}
            render={ matchProps => {
                if (!authUser.checked) {
                    return (
                        <PublicTemplate>
                            <div style={{width: '100%', textAlign: 'center'}}>
                                <Loader/>
                            </div>
                        </PublicTemplate>
                    );
                }

                if (!authUser.user) {
                    return <Redirect to={"/signin"} />;
                }
                
                if (Array.isArray(allowRoles) && allowRoles.length > 0) {
                    const currentRole = authUser.role || null;
                    if (!currentRole || !allowRoles.includes(currentRole)) {
                        return <Redirect to={"/"} />;
                    }
                }

                return (
                    <Template {...rest}>
                        <Component {...matchProps} />
                    </Template>
                );
            }}
        />
    );
}
export default withRouter(AuthRouter);
